/** @jsx jsx */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const ThreadLine = ({ children }: PropsWithChildren) => {
	return <div css={threadLineStyles}>{children}</div>;
};

export default ThreadLine;

const threadLineStyles = css({
	gridArea: 'thread-line',
	position: 'relative',
	'--commentsLineWidth': '1px',
	'--commentLineColor': token('color.background.accent.gray.subtler'),
	height: '100%',
	'&::before': {
		content: '',
		position: 'absolute',
		insetInlineStart: '50%',
		bottom: token('space.0'),
		width: 'var(--commentsLineWidth)',
		top: '0',
		backgroundColor: 'var(--commentLineColor)',
	},
});
